import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subsubmenu",
  "use": "icon-subsubmenu-usage",
  "viewBox": "0 0 1 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1 30\" id=\"icon-subsubmenu\">\n  <rect y=\"0\" class=\"st0\" width=\"1\" height=\"30\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol